export default "__VITE_ASSET__Cy903cvn__"